import React from "react";
import { Button, Modal } from "antd";
import successPic from "../../assets/img/success_pic.png";
import styles from "./BillingSuccessModal.module.css";

export default function BillingSuccessModal({
  open,
  title = "Payment successful",
  message = "Your plan purchase was completed successfully.",
  onClose,
}) {
  return (
    <Modal
      open={open}
      footer={null}
      centered
      closable={false}
      destroyOnClose
      wrapClassName={styles.modalWrap}
      bodyStyle={{ padding: 0 }}
      maskStyle={{ backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)', background: 'rgba(6, 22, 33, 0.38)' }}
      onCancel={onClose}
    >
      <div className={styles.modal}>
        <img src={successPic} alt="" className={styles.image} />
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.message}>{message}</p>
        <Button className={styles.button} type="primary" onClick={onClose}>
          Continue
        </Button>
      </div>
    </Modal>
  );
}
